export default __webpack_public_path__ + "static/media/twogiraffes.af174576.jpg";